import { faCreditCard, faFileInvoiceDollar } from "@fortawesome/pro-solid-svg-icons"
import useServiceTicketsEnabled from '../../../hooks/useServiceTicketsEnabled'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Col, Form, Row, Space, Typography } from "antd"
import { useContext } from "react"
import LabeledSwitch from "../../common/LabeledSwitch"
import VSpace from "../../common/VSpace"
import TenantsContext from "../../MyTenant/TenantsContext"

const { Text, Title } = Typography

const TenantInvoicingOptionsSection = () => {
  const showServiceTickets = useServiceTicketsEnabled()
  const { state: { tenant }, dispatch } = useContext(TenantsContext)

  return <section>
    <Title level={5}><FontAwesomeIcon icon={faFileInvoiceDollar} /> Default Invoicing Options</Title>
    <hr />
    <Form.Item label="Online Payments">
      <Row>
        <Col span={18}>
          <Space>
            <LabeledSwitch 
              label="Enable Card Payments" 
              value={tenant.enableCreditCardPayments}
              onChange={payload => dispatch({ type: 'SET_TENANT_FIELD', fieldName: 'enableCreditCardPayments', payload })}
            />
            <FontAwesomeIcon icon={faCreditCard} />
          </Space>
        </Col>
        <Col span={6}>
          <Space>
            <LabeledSwitch 
              label="Enable Bank Transfers" 
              value={tenant.enableACHPayments}
              onChange={payload => dispatch({ type: 'SET_TENANT_FIELD', fieldName: 'enableACHPayments', payload })}
            />
            <FontAwesomeIcon icon={faCreditCard} />
          </Space>
        </Col>
      </Row>
    </Form.Item>
    <hr />
    <Row>
      <Col span={8}>
        <VSpace>
          <Text>Projects</Text>
          <LabeledSwitch 
            label="Line Item Per Workarea"
            value={tenant.projectInvoiceLineItemType === 1}
            onChange={() => dispatch({ type: 'SET_TENANT_FIELD', fieldName: 'projectInvoiceLineItemType', payload: 1 })}
          />
          <LabeledSwitch 
            label="Line Item Per Workarea and Visit"
            value={tenant.projectInvoiceLineItemType === 2} 
            onChange={() => dispatch({ type: 'SET_TENANT_FIELD', fieldName: 'projectInvoiceLineItemType', payload: 2 })}
          />
          <LabeledSwitch 
            label="Line Item Per Workarea Item" 
            value={tenant.projectInvoiceLineItemType === 3}
            onChange={() => dispatch({ type: 'SET_TENANT_FIELD', fieldName: 'projectInvoiceLineItemType', payload: 3 })}
          />
        </VSpace>
      </Col>
      {showServiceTickets && <Col span={8}>
        <VSpace>
          <Text>Service Tickets</Text>
          <LabeledSwitch 
            label="Line Item Per Workarea" 
            value={tenant.serviceInvoiceLineItemType === 1}
            onChange={() => dispatch({ type: 'SET_TENANT_FIELD', fieldName: 'serviceInvoiceLineItemType', payload: 1 })}
          />
          <LabeledSwitch 
            label="Line Item Per Workarea and Visit" 
            value={tenant.serviceInvoiceLineItemType === 2}
            onChange={() => dispatch({ type: 'SET_TENANT_FIELD', fieldName: 'serviceInvoiceLineItemType', payload: 2 })}
          />
          <LabeledSwitch 
            label="Line Item Per Workarea Item" 
            value={tenant.serviceInvoiceLineItemType === 3}
            onChange={() => dispatch({ type: 'SET_TENANT_FIELD', fieldName: 'serviceInvoiceLineItemType', payload: 3 })}
          />
        </VSpace>
      </Col>}
      <Col span={8}>
        <VSpace>
          <Text>Maintenance</Text>
          <LabeledSwitch 
            label="Line Item Per Workarea" 
            value={tenant.maintenanceInvoiceLineItemType === 1}
            onChange={() => dispatch({ type: 'SET_TENANT_FIELD', fieldName: 'maintenanceInvoiceLineItemType', payload: 1 })}
          />
          <LabeledSwitch 
            label="Line Item Per Workarea and Visit" 
            value={tenant.maintenanceInvoiceLineItemType === 2}
            onChange={() => dispatch({ type: 'SET_TENANT_FIELD', fieldName: 'maintenanceInvoiceLineItemType', payload: 2 })}
          />
          <LabeledSwitch 
            label="Line Item Per Workarea Item" 
            value={tenant.maintenanceInvoiceLineItemType === 3}
            onChange={() => dispatch({ type: 'SET_TENANT_FIELD', fieldName: 'maintenanceInvoiceLineItemType', payload: 3 })}
          />
        </VSpace>
      </Col>
    </Row>
  </section>
}

export default TenantInvoicingOptionsSection